export default __webpack_public_path__ + "static/media/template_business-man__0022_5---bobbyBaldwin.bb96ea96.png";